import { withLDProvider } from "launchdarkly-react-client-sdk";

const LDProvider = withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCH_DARKLY || "",
});

export default LDProvider;
